




import { defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { FormFields, FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";

export default defineComponent({
  name: "SchedulePostView",
  components: { BaseForm },
  props: {
    values: { type: Object as () => FormValues, required: true },
  },
  computed: {
    fields(): FormFields {
      return [
        {
          name: "date",
          label: $t("Date"),
          type: "date",
        },
        {
          name: "time",
          label: $t("Time"),
          type: "time",
        },
      ];
    },
    formValues: {
      get(): FormValues {
        return this.values;
      },
      set(val: FormValues) {
        this.$emit("input", val);
      },
    },
  },
});
